import "magnific-popup";

$(document).ready(function() {
  (() => {
    const magnificInits = {
      init() {
        // Small delay to ensure DOM is fully ready
        setTimeout(() => {
          this.productImage();
          this.youtubePlayer();
        }, 100);
      },
      productImage() {
        const magnificImage = $("[data-open-magnific-image]");

        if (magnificImage.length) {
          magnificImage.magnificPopup({
            type: "image",
            closeOnContentClick: true,
            closeBtnInside: false,
            fixedContentPos: true,
            mainClass: "mfp-no-margins mfp-with-zoom",
            image: {
              verticalFit: true,
              titleSrc: false
            },
            zoom: {
              enabled: true,
              duration: 300
            },
            callbacks: {
              beforeOpen: function() {
                // Disable page scroll when modal opens
                $("body").addClass("mfp-overflow-hidden");
              },
              open: function() {
                // Add hover zoom functionality after popup opens
                magnificInits.addHoverZoom();
              },
              close: function() {
                // Re-enable page scroll when modal closes
                $("body").removeClass("mfp-overflow-hidden");
              }
            }
          });
        }
      },
      youtubePlayer() {
        const magnificYouTube = $("[data-open-magnific-youtube]");

        if (magnificYouTube.length) {
          magnificYouTube.magnificPopup({
            type: "iframe",
            mainClass: "mfp-fade",
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            iframe: {
              patterns: {
                youtube: {
                  index: "youtube.com/",
                  id: "v=",
                  src: "https://www.youtube.com/embed/%id%?autoplay=1"
                }
              }
            }
          });
        }
      },
      addHoverZoom() {
        const mfpImg = $(".mfp-img");

        if (mfpImg.length) {
          const img = mfpImg[0];
          let scale = 1;
          let isZoomed = false;

          // Create zoom container if it doesn't exist
          if (!mfpImg.parent().hasClass("mfp-zoom-container")) {
            mfpImg.wrap('<div class="mfp-zoom-container"></div>');
          }

          // Mouse move handler for zoom effect
          const handleMouseMove = e => {
            if (!isZoomed) return;
            const rect = img.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;

            mfpImg.css({
              "transform-origin": `${x}% ${y}%`,
              transform: `scale(${scale})`
            });
          };

          // Click to toggle zoom
          mfpImg.on("click", e => {
            e.preventDefault();
            e.stopPropagation();

            if (!isZoomed) {
              // Enable zoom
              isZoomed = true;
              scale = 2;
              mfpImg.css({
                transition: "transform 0.3s ease",
                cursor: "zoom-out"
              });
              // Set initial zoom position based on click position
              handleMouseMove(e);
            } else {
              // Disable zoom
              isZoomed = false;
              scale = 1;
              mfpImg.css({
                transform: "scale(1)",
                "transform-origin": "center center",
                cursor: "zoom-in",
                transition: "transform 0.3s ease"
              });
            }
          });

          // Mouse move - update zoom position when zoomed
          mfpImg.on("mousemove", handleMouseMove);

          // Set initial cursor
          mfpImg.css({
            cursor: "zoom-in"
          });
        }
      }
    };

    magnificInits.init();
  })();
});
